import { StyledSelect } from "../StyledComponents";
import { useSelector } from "react-redux";

const SelectInput = ({ action, options, fieldValue, handleChange, ...rest }) => {
  const actionValue = options?.find((o) => o.value === fieldValue);

  const excludeFields = ["payloadContentType"];
  const placeholder = excludeFields.includes(action.field) ? "" : action.label;

  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  return (
    <StyledSelect
      {...rest}
      value={actionValue}
      name={action.field}
      isSearchable={false}
      placeholder={action.label}
      isRequired={action.isRequired}
      label={placeholder}
      options={options?.sort((a, b) => a.label.localeCompare(b.label))}
      onChange={handleChange}
      isDisabled={isFlowActive || rest.disabled}
      className={`styled-select-component ${action.field === "variable_reference" ? "variable-reference-select" : ""}`}
    />
  );
};

export default SelectInput;
